module.exports = __webpack_public_path__ + "static/media/add.7ab8a63d.svg";